import { useEffect } from 'react';

export const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-6 py-16" data-testid="terms-of-service-page">
      <h1 className="font-heading text-4xl mb-8">Terms of Service</h1>
      <p className="text-gray-500 text-sm mb-8">Last Updated: March 14, 2026</p>
      
      <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
        <section>
          <h2 className="font-heading text-2xl mb-4">1. Acceptance of Terms</h2>
          <p>
            By accessing or using the Jax Remodeling Solutions LLC website and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">2. Services Description</h2>
          <p>
            Jax Remodeling Solutions LLC provides residential remodeling services including kitchen and bathroom renovations, flooring, tile work, painting, and interior renovations. All work is performed in accordance with applicable building codes and regulations.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">3. Project Estimates and Contracts</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>All estimates are valid for 30 days unless otherwise specified</li>
            <li>A signed contract is required before work begins</li>
            <li>Changes to the scope of work may result in additional charges</li>
            <li>Final pricing may vary based on actual conditions discovered during work</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">4. Payment Terms</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Payment schedules are outlined in individual project contracts</li>
            <li>Deposits may be required to secure materials and scheduling</li>
            <li>Final payment is due upon project completion</li>
            <li>Late payments may incur additional fees</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">5. Warranties</h2>
          <p>
            Jax Remodeling Solutions LLC provides workmanship warranties as specified in individual project contracts. Manufacturer warranties apply to materials and products used.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">6. Client Responsibilities</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Provide accurate project information and access to work areas</li>
            <li>Make timely decisions on materials and design selections</li>
            <li>Ensure work areas are cleared before scheduled work begins</li>
            <li>Communicate any concerns promptly</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">7. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, Jax Remodeling Solutions LLC shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">8. Intellectual Property</h2>
          <p>
            All content on this website, including but not limited to text, graphics, logos, images, and software, is the property of Jax Remodeling Solutions LLC or its licensors and is protected by copyright and other intellectual property laws.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">9. Website Use</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>You may not use the website for any unlawful purpose</li>
            <li>You may not attempt to gain unauthorized access to our systems</li>
            <li>You may not reproduce or distribute website content without permission</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">10. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the State of Florida, without regard to its conflict of law provisions.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">11. Changes to Terms</h2>
          <p>
            We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to this website. Your continued use of our services constitutes acceptance of modified terms.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">12. Contact Information</h2>
          <p>For questions about these Terms:</p>
          <ul className="list-none space-y-2 mt-4">
            <li><strong>Email:</strong> jaxremodelingsolutions@gmail.com</li>
            <li><strong>Phone:</strong> (904) 863-6673</li>
            <li><strong>Address:</strong> St. Augustine, FL</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
